export default {
	attributes: {
		design: 'fullwidth',
		showButton2: true,
		showButton3: true,
		button1LineHeightUnit: 'em',
		button1TabletLineHeightUnit: 'em',
		button1MobileLineHeightUnit: 'em',
		button1Text: 'Button text',
		button1NewTab: false,
		button2LineHeightUnit: 'em',
		button2TabletLineHeightUnit: 'em',
		button2MobileLineHeightUnit: 'em',
		button2Text: 'Button text',
		button2NewTab: false,
		button2Design: 'ghost',
		button3LineHeightUnit: 'em',
		button3TabletLineHeightUnit: 'em',
		button3MobileLineHeightUnit: 'em',
		button3Text: 'Button text',
		button3NewTab: false,
		button3Design: 'plain',
		uniqueClass: 'ugb-a83e98e',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
	},
}
